import { render, staticRenderFns } from "./PasswordUpdateForm.vue?vue&type=template&id=34bde141"
import script from "./PasswordUpdateForm.vue?vue&type=script&lang=js"
export * from "./PasswordUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports